import React from "react"

import Text from "../../common/components/Text"
import Reasons from "./Reasons"

const Synopsis = ({ diagnosis }) =>
  diagnosis.test_req ? (
    <Text>{diagnosis.test_req.description}</Text>
  ) : (
    <React.Fragment>
      <Text>{diagnosis.overview}</Text>
      <Text>{diagnosis.treatment}</Text>
      <Reasons diagnosis={diagnosis}/>
    </React.Fragment>
  )

export { Synopsis as default }



// WEBPACK FOOTER //
// ./assets/completion/components/Synopsis.js